module.exports = __webpack_public_path__ + "static/media/create.950ce500.mov";


//////////////////
// WEBPACK FOOTER
// ./src/projects/rostery/src/create.mov
// module id = 618
// module chunks = 0